import React from "react";
import "./NSAGFE.css";

const NSAGFE = () => {
  return (
    <div className="nsaContainer">
      <div className="nsaTitle">
        You have the right to receive a "Good Faith Estimate" explaining how
        much your medical care will cost.
      </div>
      <div className="nsaBody">
        Under Section 2799B-6 of the Public Health Service Act, health care
        providers and health care facilities are required to inform individuals
        who are not enrolled in a plan or coverage, a Federal health care
        program, or not seeking to file a claim with their plan or coverage;
        both orally and in writing of their ability, upon request or at the time
        of scheduling health care items and services, to receive a "Good Faith
        Estimate" of expected charges. Under the law, health care providers need
        to give patients who do not have insurance or who are not using
        insurance, an estimate of the bill for medical items and services.
        <ul className="nsaList">
          <li className="nsaListItem">
            You have the right to receive a Good Faith Estimate for the total
            expected cost of any non-emergency items or services. This includes
            related costs like medical tests, prescription drugs, equipment, and
            hospital fees.
          </li>
          <li className="nsaListItem">
            Make sure your health care provider gives you a Good Faith Estimate
            in writing at least 1 business day before your medical service or
            item. You can also ask your health care provider, and any other
            provider you choose, for a Good Faith Estimate before you schedule
            an item or service.
          </li>
          <li className="nsaListItem">
            If you receive a bill that is at least $400 more than your Good
            Faith Estimate, you can dispute the bill.
          </li>
          <li className="nsaListItem">
            Make sure to save a copy or picture of your Good Faith Estimate.
          </li>
        </ul>
        For questions or more information about your right to a Good Faith
        Estimate, visit www.cms.gov/nosurprises or call (800) 368-1019 and talk
        to your therapist.
      </div>
    </div>
  );
};

export default NSAGFE;
